import React from 'react';
import styles from './DemoNotFilledUserData.module.css'
import image from '../../../../uploads/images/demo3.jpg'
// import image from '../../../../uploads/images/demoNotAllData.jpg'
import LayoutContentWrapper from "../../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ImageForHorizon from "../../../../components/Utils/Images/ImageForHorizon/ImageForHorizon";
import DemoForm from "./DemoForm/DemoForm";

const DemoNotFilledUserData = () => {
    return (
        <div className={styles.wrapper}>
            <ImageForHorizon blurhash={'QDDb~3IUbaWBIURkR*j]M|.TaKahWBRPWCaxogRj.8NGt7RjRjofayt7WB'} src={image}/>
            <LayoutContentWrapper>
                <p>Совсем скоро Вы уже сможете попробовать демо-версию «МИС», осталось только дозаполнить некоторые данные :)</p>
            </LayoutContentWrapper>
            <div className={styles.formWrapper}>
                <LayoutContentWrapper>
                    <DemoForm />
                </LayoutContentWrapper>
            </div>
        </div>
    );
};

export default DemoNotFilledUserData;